import native from '@zz-common/native-adapter'
import { setCookie } from '@/utils/cookie'
const asyncAdapter = (method, params, callback) => native.wrap(method)(params, callback)

export const nativeGetUserInfo = (params, callback) => {
  asyncAdapter('getUserInfo', params, callback)
}

export const nativeGetRecycleInfo = (params, callback) => {
  asyncAdapter('getRecycleInfo', params, callback)
}

export const nativeGetPhoneInfo = (params, callback) => {
  asyncAdapter('getPhoneInfo', params, callback)
}

export const nativeGetContextInfo = (params, callback) => {
  asyncAdapter('getContextInfo', params, callback)
}

export const nativeSetTitle = (params, callback) => {
  asyncAdapter('setTitle', params, callback)
}

export const nativeLogin = (params) => {
  const insetCallback = params.callback

  params.callback = function(res) {
    if (!res) {
      return
    }

    if (res.token) {
      setCookie('PPU', `"${res.token}"`)
    }

    insetCallback && insetCallback(res)
  }

  asyncAdapter('login', params)
}

export const nativePasteText = (params, callback) => {
  asyncAdapter('pasteText', params, callback)
}
export const nativeNewPasteText = (params, callback) => {
  asyncAdapter('zljPasteText', params, callback)
}

export const nativeEnterUnifiedUrl = (params, callback) => {
  asyncAdapter('enterUnifiedUrl', params, callback)
}

export const nativeProductDetailShare = (params, callback) => {
  asyncAdapter('productDetailShare', params, callback)
}

export const nativeGetStatusBarHeight = (params, callback) => {
  asyncAdapter('getStatusBarHeight', params, callback)
}

export const nativeIsStatusBarSupportTransparent = (params, callback) => {
  asyncAdapter('isStatusBarSupportTransparent', params, callback)
}

export const nativeSetStatusBarDarkMode = (params, callback) => {
  asyncAdapter('setStatusBarDarkMode', params, callback)
}

export const nativeClose = (params, callback) => {
  asyncAdapter('close', params, callback)
}

export const nativeOpenShare = (params, callback) => {
  asyncAdapter('openShare', params, callback)
}
export const nativeSlideCode = (params, callback) => {
  asyncAdapter('registerSlider', params, callback)
}
export const nativeIsLogin = () => {
  return native.isLogin()
}
export const nativeLogOut = (params, callback) => {
  asyncAdapter('logout', params, callback)
}
export const nativeCancelAccount = (params, callback) => {
  asyncAdapter('cancelAccount', params, callback)
}
export const nativeIsOpenNotify = (params, callback) => {
  asyncAdapter('isOpenNotify', params, callback)
}
export const nativeOpenNotifySetting = (params, callback) => {
  asyncAdapter('openNotifySetting', params, callback)
}
export const nativeFocusWechatOfficialAccount = (params, callback) => {
  asyncAdapter('focusWechatOfficialAccount', params, callback)
}
export const nattiveGetNetworkTypeAndOperator = (params, callback) => {
  asyncAdapter('getNetworkTypeAndOperator', params, callback)
}

// 取消隐私协议
export const nattiveCancelPrivacyAgreement = (params, callback) => {
  asyncAdapter('cancelPrivacyAgreement', params, callback)
}

// 是否是浏览模式
export const nattiveIsBrowseMode = (params, callback) => {
  asyncAdapter('isBrowseMode', params, callback)
}

// 显示浏览模式弹窗
export const nattiveShowPrivacyAgreementPopView = (params, callback) => {
  asyncAdapter('showPrivacyAgreementPopView', params, callback)
}

// 分享
export const pageShare = (params, callback) => {
  asyncAdapter('shareClick', params, callback)
}
